import { NeonDbClient } from "./dbClient";

let accessTokenGetter: () => string | null = () => null;

/** Called from AuthProvider when the session changes. */
export function setNeonAccessTokenGetter(fn: () => string | null) {
  accessTokenGetter = fn;
}

/** Drop-in replacement for `db.from` / `db.rpc` (data only). */
export const db = new NeonDbClient(() => accessTokenGetter());
